export default {
  teamInfoTitle: "Gestion de l'entreprise",
  createTeamLabel: "Créez votre entreprise pour gérer vos sites et vos postes avec d'autres utilisateurs!",
  createTeamBtn: 'Créer une entreprise',
  editTeamLabel: "Modifier le nom de l'entreprise",
  addTeamBtn: 'Inviter un nouveau membre',
  teamSearchPlaceholder: 'Rechercher des membres',
  accountInviteCheck: {
    teamInvitationSuccess: "Vous avez rejoint cette équipe avec succès grâce à l'invitation!",
    teamInvitationFailed: "Une erreur s'est produite lors de la tentative de rejoindre cette équipe.",
    warningTitle: 'Avertissement : Transfert de compte permanent',
    warningBody: "Vous avez été invité à rejoindre le compte d'une organisation.",
    warningBodyExtra:
      "Sachez qu'en acceptant cette invitation, votre profil sera transféré vers cette nouvelle organisation. Toutes les données associées à votre organisation actuelle, y compris les candidats, les postes et les messages, ne vous seront plus accessibles. Cette action est irréversible.",
    toProceedText: 'Pour transférer votre profil vers cette organisation, cliquez sur',
    joinCompany: "Rejoindre l'organisation",
    cancel: 'Annuler',
  },
  teamInfoTableHeader: {
    name: 'Nom',
    status: 'Statut',
    phoneNumber: 'Numéro de téléphone',
    action: 'Options',
  },
  teamInviteTableHeader: {
    email: 'Courriel',
    status: 'Statut',
    action: 'Options',
  },
  accountInviteInfo: "Invitations en attente d'une réponse",
  confirmationMessage: {
    promote: `Êtes-vous sûr de vouloir donner des droits administratifs à {{teamMemberName}}?`,
    demote: `Êtes-vous sûr de vouloir enlever les droits administratifs de {{teamMemberName}}?`,
    delete: `Êtes-vous sûr de vouloir retirer {{teamMemberName}} de la société ?`,
    cancel: `Êtes-vous sûr de vouloir annuler l'invitation envoyée à {{inviteEmail}}?`,
    reInvite: `Êtes-vous sûr de vouloir renvoyer une invitation à {{inviteEmail}}?`,
    restrict: `Are you sure you want to restrict {{teamMemberName}} from position?`,
    unRestrict: `Are you sure you want to unrestrict {{teamMemberName}} from position?`,
  },
  successMessage: {
    promote: `{{teamMemberName}} a maintenant des droits administratifs.`,
    demote: `{{teamMemberName}} n'a plus de droits administratifs.`,
    delete: `{{teamMemberName}} a été supprimé du compte.`,
    cancel: `L'invitation destinée à {{inviteEmail}} a été annulée avec succès.`,
    reInvite: `L'invitation destinée à {{inviteEmail}} a été renvoyée avec succès.`,
    restrict: `{{teamMemberName}} is successfully restricted from position.`,
    unRestrict: `{{teamMemberName}} is successfully unrestricted from position.`,
  },
  createTeamModal: {
    createLabel: 'Nommez votre entreprise',
    editLabel: "Modifier le nom de l'entreprise",
    cancelBtn: 'Annuler',
    saveBtn: 'Confirmer',
    updateBtn: 'Mettre à jour',
    successMessage: {
      create: "Nom de l'entreprise sauvegardé avec succès",
      update: "Nom de l'entreprise modifié avec succès",
    },
    validationMessage: {
      name: "Le nom de l'entreprise est requis",
      empty: 'Le courriel est requis',
      validation: 'Le courriel doit être une adresse valide',
    },
  },
  inviteTeamModal: {
    inviteLabel: 'Inviter un nouveau membre',
    inviteEmailPlaceholder: 'Courriel',
    cancelBtn: 'Annuler',
    saveBtn: 'Envoyer',
    validationMessage: {
      empty: 'Le courriel est requis',
      validation: 'Le courriel doit être une adresse valide',
    },
  },
  noData: 'Aucune donnée trouvée.',
  noPendingInvitation: 'Aucune invitation en attente trouvée',
  cancelInvite: "Annuler l'invitation",
  resend: 'Renvoyer',
  confirmBtn: 'Confirmer',
  cancelBtn: 'Annuler',
  admin: 'Administrateur',
  superAdmin: 'Super Administrateur',
  restrictedRecruiter: 'Restricted Recruiter',
  active: 'Actif',
  pending: 'En attente',
  expired: 'Expiré',
  menuItems: {
    allowPermissions: 'Modifier les permissions',
    removeAccount: 'Retirer du compte',
    revokeAdmin: `Révoquer le statut d'administrateur`,
    makeAdmin: `Nommer administrateur`,
    restrictUserPosition: 'Restrict Positions',
    unRestrictUserPosition: 'Unrestrict Positions',
  },
  hasAdminAccess: `A les permissions d'administrateur`,
  hasRequestAccess: `A les permissions de demande/resoumission`,
  hasReviewAccess: 'A les permissions de révision',
  permissionModal: {
    title: 'Permissions',
    subTitle: `Gérer les autorisations permettant aux utilisateurs d'accéderaux formulaires des candidats et d'en faire la demande.`,
    cancelBtn: 'Annuler',
    confirmBtn: 'Confirmer',
    successMessage: 'Permissions mises à jour avec succès.',
    backgroundCheck: {
      heading: `Vérification d'antécédents`,
      admin: {
        title: 'Administrateur',
        description: `Peut configurer le processus de vérification des antécédents.`,
      },
      review: {
        title: 'Révision',
        description: `Peut uniquement consulter les résultats des vérifications. Aucune action possible.`,
      },
      request: {
        title: 'Demande / Resoumission',
        description: `Peut initier des demandes de vérification des antécédents et prendre des mesures (approuver, refuser, demander une nouvelle soumission).`,
      },
    },
    hrForm: {
      heading: 'Formulaire RH',
      admin: {
        title: 'Administrateur',
        description:
          'Peut configurer le processus du formulaire RH, y compris créer, modifier et copier des modèles de formulaire RH.',
      },
      review: {
        title: 'Révision',
        description: `Peut uniquement consulter les soumissions de formulaire RH. Aucun droit de modification ou d’approbation.`,
      },
      request: {
        title: 'Demande / Resoumission',
        description: `Peut lancer des demandes de formulaires RH, les examiner et prendre des mesures (approuver, refuser, demander une nouvelle soumission).`,
      },
    },
    i9Form: {
      heading: 'Formulaires I-9',
      admin: {
        title: 'Administrateur',
        description: 'Peut configurer le processus de vérification I-9.',
      },
      review: {
        title: 'Révision',
        description: `Peut accéder aux soumissions I-9 et les consulter. Aucun droit d’action.`,
      },
      request: {
        title: 'Demande / Resoumission',
        description:
          'Peut démarrer des demandes de vérification I-9 et prendre des mesures (approuver, refuser, demander une nouvelle soumission).',
      },
    },
  },
};
